var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-booking-event-table',{attrs:{"title":_vm.$t('global.bookings_payments_follow_up_page.title'),"display-config-name":'payments-follow-up',"filter-config-name":'payments-follow-up'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }